<script setup lang="ts">
import { getIconComponent } from '../icons/utils';

type ButtonType = "button" | "submit" | "reset";

interface Props {
	icon: string;
	onClick: Function;
	text?: string;
	type?: ButtonType;
	index?: number;
	isActive?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	text: "",
	type: "button",
	isActive: false,
} );

</script>

<template>
	<button :type="props.type" :class="['button', props.isActive ? 'button--active' : '']" @click="props.onClick">
		<span class="button__icon" aria-hidden="true">
			<component :is="getIconComponent(props.icon)" />
		</span>
		<span class="button__text" v-if="props.text">
			{{ props.text }}
		</span>
	</button>
</template>

<style scoped lang="scss">
.button {
	@include font-size(14px, 18px);
	border-color: transparent;
	background-color: transparent;
	border-radius: 4px;
	width: 100%;
	padding: 0;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-weight: normal;
	white-space: inherit;

	@include hover-focus-style {
		border-color: transparent;
	}

	&:focus {
		outline: none;
	}

	&:focus-visible {
		outline-offset: -2px;
		outline-style: auto;
		outline-width: 5px;
	}

	&--active {
		font-weight: bold;
	}

	.button__icon {
		position: relative;
	}

	:deep(svg) {
		pointer-events: none;
	}
}
</style>
